import * as React from 'react';
import { SVGProps } from 'react';

const IconRemoveSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M2 7h12v2H2z" />
  </svg>
);
export default IconRemoveSizeS;
